// src/pages/PublicServiceProductsPage.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/Client";
import {API_BASE} from "../config.ts";

interface ServiceProduct {
  id: number;
  name: string;
  description?: string | null;
  session?: number | null;
  price?: number | null;
  discount?: number | null;
  image?: string | null;
  type_of_product?: string | null;
}

export default function PublicServiceProductsPage() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const [products, setProducts] = useState<ServiceProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadProducts() {
      try {
        const resp = await api.get("/api/customers/catalog/service-products", {
          params: { primary_service_id: serviceId },
        });
        setProducts(Array.isArray(resp.data) ? resp.data : []);
      } catch (err) {
        console.error("Error al cargar productos:", err);
      } finally {
        setLoading(false);
      }
    }
    if (serviceId) loadProducts();
  }, [serviceId]);

  return (
    <div style={{ minHeight: "100vh", padding: "1rem" }}>

      <h3 style={{ textAlign: "center", marginBottom: "1rem" }}>
        Productos del servicio
      </h3>

      {loading && <p>Cargando…</p>}
      {!loading && products.length === 0 && <p>No hay productos disponibles.</p>}

      {products.map((prod) => (
        <div
          key={prod.id}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0.75rem",
            marginBottom: "0.5rem",
            border: "1px solid #eee",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          {prod.image && prod.image !== "default.png" && (
            <img
              src={`${API_BASE}/api/product_images/${prod.image}`}
              alt={prod.name}
              onError={(event) => {
                event.currentTarget.style.display = "none";
              }}
              style={{
                width: "60px",
                height: "60px",
                objectFit: "contain",
                marginRight: "12px",
              }}
            />
          )}
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, fontSize: "0.95rem" }}>
              {String(prod.name || "").toUpperCase()}
            </div>
            {prod.session != null && (
              <div style={{ fontSize: "0.8rem", color: "#777" }}>
                Sesiones: {prod.session}
              </div>
            )}
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: "#c62828", fontWeight: 600 }}>
              {Math.round(prod.price ?? 0)}€
            </div>
            <button
              onClick={() => navigate("/home")}
              style={{
                marginTop: "8px",
                marginLeft: "3px",
                background: "transparent",
                color: "#B71C1C",
                border: "1px solid #B71C1C",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "0.85rem",
                fontWeight: 600,
              }}
            >
              Accede a la app
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
